export type PromotionSurface =
  | 'marketplace'
  | 'marketplace-card'
  | 'marketplace-detail'
  | 'landing';

export const PROMOTION_SURFACES: PromotionSurface[] = [
  'marketplace',
  'marketplace-card',
  'marketplace-detail',
  'landing',
];

export type PromotionFieldType = 'text' | 'email' | 'tel';

export interface PromotionField {
  name: string;
  label: string;
  type: PromotionFieldType;
  required: boolean;
  max_length?: number;
  regex?: string;
}

export interface Promotion {
  promo_id: string;
  title: string;
  subtitle?: string;
  cta_text: string;
  success_text: string;
  consent_text?: string;
  fields: PromotionField[];
  tenants: string[];
  surfaces: PromotionSurface[];
  start_at?: string | null;
  end_at?: string | null;
  is_active: boolean;
  auto_popup: boolean;
  created_at?: string;
  updated_at?: string;
  created_by?: string;
  updated_by?: string;
  lead_count?: number;
}

export type LeadStatus =
  | 'NEW'
  | 'CONTACTED'
  | 'QUALIFIED'
  | 'CONVERTED'
  | 'DROPPED';

export const LEAD_STATUSES: LeadStatus[] = [
  'NEW',
  'CONTACTED',
  'QUALIFIED',
  'CONVERTED',
  'DROPPED',
];

export interface Lead {
  pk: string;
  sk: string;
  promo_id: string;
  lead_id: string;
  tenant: string;
  source: string;
  basket_id?: string;
  data: Record<string, string>;
  status: LeadStatus;
  notes: string;
  status_updated_at: string;
  status_updated_by: string;
  created_at: string;
}

export interface SubmitLeadPayload {
  source?: PromotionSurface;
  tenant?: string;
  basket_id?: string;
  [fieldName: string]: any;
}

export interface PromotionListResponse {
  success: boolean;
  data: Promotion[];
}

export interface PromotionDetailResponse {
  success: boolean;
  data: Promotion;
}

export interface LeadListResponse {
  success: boolean;
  data: Lead[];
  cursor?: string | null;
}

export interface LeadUpdateResponse {
  success: boolean;
  data: Lead;
}
